import axios from 'axios';
const {
	disabledContext,
	unwrapResponse,
	validateBootstrapPath,
	validatePortalContext,
	validateSameOriginPath,
	withFrontendLoginPath,
} = require('./portal-context-contract');

let portalContext = disabledContext;

function optionalPositiveEnvironmentInteger(value, fieldName) {
	if (value === undefined || value === null || String(value).trim() === '') return undefined;
	const parsed = Number(value);
	if (!Number.isSafeInteger(parsed) || parsed <= 0 || parsed > 2147483647) {
		throw new Error(`Invalid SSO ${fieldName}.`);
	}
	return parsed;
}

function isRuntimeSsoRequested() {
	return process.env.VUE_APP_SSO_ENABLED === 'true';
}

async function initializePortalContext() {
	if (!isRuntimeSsoRequested()) {
		portalContext = disabledContext;
		return portalContext;
	}

	const path = validateBootstrapPath(process.env.VUE_APP_SSO_PUBLIC_CONTEXT_PATH, window.location.origin);
	const requestTimeout = optionalPositiveEnvironmentInteger(
		process.env.VUE_APP_SSO_REQUEST_TIMEOUT_MS,
		'request timeout',
	);
	const response = await axios.get(path, {
		baseURL: window.location.origin,
		withCredentials: true,
		...(requestTimeout === undefined ? {} : { timeout: requestTimeout }),
		ssoSkipUnauthorizedRedirect: true,
	});
	portalContext = withFrontendLoginPath(
		validatePortalContext(unwrapResponse(response.data), window.location.origin),
		process.env.VUE_APP_LEGACY_LOGIN_PATH,
		window.location.origin,
	);
	return portalContext;
}

function getPortalContext() {
	return portalContext;
}

function getSsoRequestTimeoutMs() {
	return optionalPositiveEnvironmentInteger(
		process.env.VUE_APP_SSO_REQUEST_TIMEOUT_MS,
		'request timeout',
	);
}

export {
	disabledContext,
	getPortalContext,
	getSsoRequestTimeoutMs,
	initializePortalContext,
	isRuntimeSsoRequested,
	unwrapResponse,
	validateBootstrapPath,
	validatePortalContext,
	validateSameOriginPath,
	withFrontendLoginPath,
};
